import { render, staticRenderFns } from "./MemberWarningPopup.vue?vue&type=template&id=008a4c57"
import script from "./MemberWarningPopup.vue?vue&type=script&lang=js"
export * from "./MemberWarningPopup.vue?vue&type=script&lang=js"
import style0 from "./MemberWarningPopup.vue?vue&type=style&index=0&id=008a4c57&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports